module.exports = __webpack_public_path__ + "img/elements.d292c8c2.png";